import React, { useEffect } from "react";
import { Button, Card, Table, Space, Switch, message, Upload } from "antd";
import { useHistory } from "react-router-dom";
import { useModel } from "../../../models";
import { goPage } from "../../layout/pageDefinition";
import MaterialService from "./MaterialService";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const [
        { materialSortDict, engineTypeDict },
        { getMaterialSortDict }] = useModel("cmDict");
    const history = useHistory();
    const [
        { searchParam, materialList, pageInfo, selectedRowKeys, selectedMaterial },
        { setSelectedRowKeys, setSearchParam, setSelectedMaterial, loadMaterialList, enableOrDisable }
    ] = useModel("material");

    useEffect(() => {
        let data = {
            "pageSize": 15,
            "pageNum": 1
        }
        loadMaterialList({ showMsg: false, data });
        setSearchParam({})

        getMaterialSortDict()
    }, [])
    const onAdd = () => {
        goPage(history, "6-1-2");
    }
    const onEdit = () => {
        let findCustomerList = materialList.find(item => {
            if (item.key === selectedMaterial.key) {
                return item
            }
        })
        setSelectedMaterial(findCustomerList)
        setSelectedRowKeys([findCustomerList.key]);
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            goPage(history, "6-1-1");
        } else {
            message.error("请选择物料!", 5);
        }

    }

    const onExport = async () => {
        let { materialCode, materialName, replaceNum, engineType, category } = searchParam
        let { pageSize, pageNum } = pageInfo
        let res = {
            type: "post",
            data: {
                ...searchParam,
                pageSize,
                pageNum
            }
        }
        await MaterialService.export(res);
    }
    const onDownload = async () => {
        await MaterialService.downloadTpl();
    }

    const onDisabled = (key, checked) => {
        //先做禁用/启用操作
        let data = {
            id: key,
            materialStatus: checked ? 0 : 1
        }
        enableOrDisable({ data })
        //更新列表状态或重新加载数据
    }
    const onPageChange = (page, pageSize) => {
        const params = { ...searchParam };
        params.pageNum = page;
        params.pageSize = pageSize;
        loadMaterialList({ showMsg: false, data: params });
    }
    const filterTree = (treeData, id) => {
        for (let i = 0; i < treeData.length; i++) {
            if (treeData[i].key && treeData[i].key === id) {
                // console.log(treeData[i].title,treeData[i].key, "id===="+id)
                return treeData[i].title;
            } else if (treeData[i].children && treeData[i].children.length > 0) {
                let find = filterTree(treeData[i].children, id);
                if (find) return find
            }
        }
    }
    const columns = [
        {
            title: '序号',
            width: 80,
            render: (text, record, index) => `${index + 1}`,
        },
        {
            title: '商品编号',
            dataIndex: 'materialCode',
            align: 'left',
            width: 200
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
            width: 200
        },
        {
            title: '图号',
            dataIndex: 'replaceNum',
            width: 200
        },
        {
            title: '商品类型',
            dataIndex: 'category',
            width: 200,
            render: (text, record) => {
                return (
                    <span>
                        {
                            filterTree(materialSortDict, text)
                        }
                    </span>
                )
            }

        },
        {
            title: '发动机型号',
            dataIndex: 'engineType',
            width: 200,
            render: (text, record) => {
                return (
                    <span>
                        {
                            engineTypeDict.map((item) => {
                                if (item.key === text) {
                                    return item.label
                                }
                            })
                        }
                    </span>
                )
            }
        },
        {
            title: '进货价格',
            width: 150,
            dataIndex: 'purchasePrice',
        },
        {
            title: '销售价格',
            width: 150,
            dataIndex: 'salesPrice',
        },
        {
            title: '二级销价',
            width: 150,
            dataIndex: 'subSalesPrice',
        },
        {
            title: '创建时间',
            width: 150,
            dataIndex: 'createTime',
        },
        {
            title: '修改时间',
            width: 150,
            dataIndex: 'updateTime',
        },
        {
            title: '备注',
            dataIndex: 'materialDesc',
            width: 300,
        },
        {
            title: '操作',
            key: 'action',
            width: 50,
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={record.materialStatus === 0} onChange={(checked) => {
                        onDisabled(record.id, checked);
                    }} />
                </Space>
            ),
        },
    ];
    const onUploadSuccess = (retData) => {
        console.log(retData);
        let data = {
            "pageSize": 15,
            "pageNum": 1
        }
        loadMaterialList({ showMsg: false, data });
    }

    return (
        <Card
            bordered={true}
            title={
                <div style={{ marginTop: "12px" }}>
                    <YhAuth resCode={ResourceAuthEnum.DATA_M_AD}>
                        <Button type="primary" onClick={onAdd}>新增</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.DATA_M_ED}>
                        <Button className="margin-left-8" onClick={onEdit} disabled={!!!selectedMaterial}>编辑</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.DATA_M_IM}>
                        <Upload {...MaterialService.getImportCfg({ onUploadSuccess })}>
                            <Button className="margin-left-8">导入</Button>
                        </Upload>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.DATA_M_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.DATA_M_DLOAD}>
                        <Button className="margin-left-8" onClick={onDownload}>下载模板</Button>
                    </YhAuth>
                </div>
            }
            className="margin-top-8"
        >
            <Table
                columns={columns}
                dataSource={materialList}
                bordered
                pagination={{
                    hideOnSinglePage: true,
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: onPageChange,
                    total: pageInfo.total,
                    current: pageInfo.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedMaterial && selectedMaterial.key === record.key) {
                                setSelectedMaterial(null);
                                setSelectedRowKeys([]);
                            } else {
                                setSelectedMaterial(record);
                                setSelectedRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedRowKeys(selectedRowKeys);
                        setSelectedMaterial(selectedRows[0]);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled User',
                        name: record.id,
                    }),
                    selectedRowKeys: selectedRowKeys
                }}
                scroll={{ x: 'max-content' }}
            />
        </Card>
    )

};